export default __webpack_public_path__ + "static/media/Visual-Properties_A1.30d63ff5.pdf";